"use client";

import Image from "next/image";
import HeadingSize from "@/components/ui/HeadingSize";
import ResponsivePicture from "../ui/ResponsivePicture";
import { AnimatedOptimizedImageDebounced as AnimatedOptimizedImage } from "@/components/shared/AnimatedOptimizedImage";

export default function TrustStatsSection() {
  return (
    <section
      className="w-full py-12 md:py-24 relative xl:pt-[200px] bg-[#F8F6F9]"
      aria-labelledby="trust-heading"
    >
      {/* Top Decoration Image */}
      <div className="h-[160px] absolute top-[0px] md:-top-[150px] right-0 z-10">
        <ResponsivePicture
          baseSrc="/images/home/Ingredient/2nd"
          alt="Floating Graphic Decoration"
          className="object-contain w-[100px] h-[120px] md:h-[300px] md:w-[250px]"
          width={160}
          height={160}
        />
      </div>

      <div className="container mx-auto px-4">
        {/* Heading */}
        <div className="text-center mb-16 md:mb-6 lg:mb-16" id="trust-heading">
          <HeadingSize text="Why do people" />
          <HeadingSize text="trust Ryze?" />
        </div>

        {/* Main Stats Row */}
        <div className="flex flex-row sm:gap-4 max-w-4xl mx-auto">
          {/* 3 Lakh Stats Image */}
          <div className="w-[60%] sm:w-full md:w-1/2 text-center">
            <div className="relative max-w-full w-[200px] h-[150px] sm:w-[400px] sm:h-[240px] mx-auto mb-4">
              <ResponsivePicture
                baseSrc="/images/home/3lakh"
                alt="3 Lakh Users Trusted"
                className="object-contain"
                fill={true}
              />
            </div>
          </div>

          {/* Right Side - People Stats */}
          <div className="w-[40%] sm:w-full md:w-1/2 text-center">
            <div className="relative w-[100px] sm:w-[220px] h-[80px] sm:h-[120px] mx-auto mb-4">
              <Image
                src="/images/home/peopleIcon.webp"
                alt="People Statistics"
                fill
                className="object-contain"
              />
            </div>
            <p className="text-sm sm:text-xl md:text-[28px] md:leading-snug font-['Ainslie_Sans'] text-black text-center leading-tight">
              6 out of 10 customers
              <br />
              want to break free
              <br />
              from bad habits
            </p>
          </div>
        </div>

        {/* Features List */}
        <div className="mt-4 max-w-[240px] sm:mt-12 md:max-w-md mx-auto space-y-4 lg:space-y-12 items-start  font-medium">
          <div className="flex items-start gap-5">
            <img
              src="/images/home/tickmark.webp"
              alt="FDA Approved"
              className="w-5 h-5 md:w-8 md:h-8 lg:w-8 mt-2"
            />
            <span className="text-[20px] md:text-[32px]  font-['Ainslie_Sans'] font-semibold text-[#000000]">
              FDA-approved
            </span>
          </div>
          <div className="flex items-start gap-5 ">
            <img
              src="/images/home/tickmark.webp"
              alt="No Strain"
              className="w-5 h-5 md:w-8 md:h-8 lg:w-8 mt-2"
            />
            <span className="text-[20px] md:text-[32px]  font-['Ainslie_Sans'] font-semibold text-[#000000]">
              No strain on
              <br />
              the jaw and throat
            </span>
          </div>
          <div className="flex items-start  gap-5">
            <img
              src="/images/home/tickmark.webp"
              alt="Safe"
              className="w-5 h-5 md:w-8 md:h-8 lg:w-8 mt-2"
            />
            <span className="text-[20px] md:text-[32px]  font-['Ainslie_Sans'] font-semibold text-[#000000]">
              Safe and flavourful, with a gentle release of flavours
            </span>
          </div>
        </div>
      </div>

      {/* Bottom Decoration Image */}
      <div className="h-[100px] md:h-[200px] lg:h-[300px] absolute bottom-[-10px] md:bottom-[40px] left-0 z-10">
        <ResponsivePicture
          baseSrc="/images/home/Ingredient/1st"
          alt="Floating Decoration"
          className="object-contain w-[50px] h-[100px] md:w-[140px] md:h-[200px] lg:w-[140px] lg:h-[300px]"
          width={160}
          height={200}
        />
      </div>
    </section>
  );
}
